/* (ignored) */


//////////////////
// WEBPACK FOOTER
// jsdom (ignored)
// module id = 6
// module chunks = main